import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import lodash from 'lodash';

class LocationItem extends React.Component {
  render() {
    const { checked, name } = this.props;

    return (
      <label>
        <input
          type="checkbox"
          style={{ width: 'auto', marginRight: '6px' }}
          checked={checked}
          onChange={this.handlerToggleLocation}
        />
        {name}
      </label>
    );
  }

  handlerToggleLocation = e => {
    this.props.onToggleLocation(this.props.id, e.target.checked);
  };
}

LocationItem.propTypes = {
  id: PropTypes.number,
  name: PropTypes.string,
  checked: PropTypes.bool,
  onToggleLocation: PropTypes.func
};

class ModalEditCreate extends React.Component {
  state = {
    name: '',
    locationIds: [],
    loading: false
  };

  modalRef = null;

  componentDidMount() {
    $(this.modalRef).on('hide.bs.modal', () => {
      this.setState({ name: '', locationIds: [] });
      this.props.onClosed();
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.visible !== this.props.visible) {
      if (nextProps.visible) {
        if (nextProps.dataEdit) {
          const ids = nextProps.dataEdit.locations.map(item => item.id);
          this.setState({
            name: nextProps.dataEdit.name,
            locationIds: ids
          });
        }

        $(this.modalRef).modal('show');
      }
    }
  }

  render() {
    const { name, locationIds, loading } = this.state;
    const { dataEdit, locations } = this.props;
    const title = dataEdit ? `Edit ${dataEdit.name}` : 'Add Group';

    return (
      <div>
        <div
          role="dialog"
          className="modal fade"
          ref={el => (this.modalRef = el)}
          tabIndex={0}    
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <a
                className="pull-right close-button link-color pointer-hand"
                data-dismiss="modal"
                tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && e.currentTarget.click()}
              >
                <i className="material-icons md-35">close</i>
              </a>
              <div className="modal-header">
                <h1 className="modal-title">{title}</h1>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-xs-12 col-md-12">
                    <label htmlFor='settings-add-group-name'>Name *</label>
                    <input
                      className="form-control"
                      id='settings-add-group-name'
                      value={name}
                      onChange={this.handlerChangeName}
                    />
                  </div>
                  <div className="col-xs-12 col-md-12">
                    <button
                      type="button"
                      className="btn btn-text margin-right-five"
                      onClick={() => this.handlerToggleAllLocations(true)}
                    >
                      Select All
                    </button>
                    <button
                      type="button"
                      className="btn btn-text"
                      onClick={() => this.handlerToggleAllLocations(false)}
                    >
                      Deselect All
                    </button>
                    <hr />
                    <div
                      style={{
                        maxHeight: 500,
                        overflowY: 'auto'
                      }}
                    >
                      {locations.map((location, index) => (
                        <span key={location.id}>
                          {index === 0 ? null : <br />}
                          <LocationItem
                            id={location.id}
                            name={location.name}
                            checked={locationIds.indexOf(location.id) !== -1}
                            onToggleLocation={this.handlerToggleLocation}
                          />
                        </span>
                      ))}
                    </div>
                  </div>
                </div>

                <br />

                <a
                  tabIndex={0}
                  className={`btn btn-pink btn-block btn-raised${
                    !name || locationIds.length === 0 || loading
                      ? ' disabled'
                      : ''
                  }`}
                  onKeyDown={(e) => e.key === 'Enter' && this.handlerSubmit()}
                  onClick={this.handlerSubmit}
                >
                  SAV{loading ? 'ING...' : 'E'}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  handlerChangeName = e => this.setState({ name: e.target.value });

  handlerToggleLocation = (id, checked) => {
    const tmp = this.state.locationIds;

    if (checked) {
      tmp.push(id);
    } else {
      const idx = tmp.indexOf(id);
      tmp.splice(idx, 1);
    }

    this.setState({ locationIds: tmp });
  };

  handlerToggleAllLocations = toggle => {
    let ids = [];

    if (toggle) {
      ids = this.props.locations.map(item => item.id);
      this.setState({ locationIds: ids });
    } else {
      this.setState({ locationIds: ids });
    }
  };

  handlerSubmit = () => {
    this.setState({ loading: true });

    const locationIds = this.state.locationIds;
    const data = {
      name: this.state.name,
      location_groups_attributes: locationIds.map(item => ({
        location_id: item
      }))
    };

    if (this.props.dataEdit) {
      // Checking current location to delete it
      data.location_groups_attributes = this.props.dataEdit.location_groups.map(
        item => {
          return {
            id: item.id,
            location_id: item.location_id,
            _destroy: locationIds.indexOf(item.location_id) === -1
          };
        }
      );

      // Addition new locations
      locationIds.forEach(id => {
        const idx = lodash.findIndex(data.location_groups_attributes, {
          location_id: id
        });
        if (idx === -1) {
          data.location_groups_attributes.push({
            location_id: id
          });
        }
      });

      axios
        .put(`/groups/${this.props.dataEdit.id}`, data)
        .then(this.success)
        .catch(this.error);
    } else {
      axios
        .post('/groups', data)
        .then(this.success)
        .catch(this.error);
    }
  };

  success = resp => {
    this.setState({ loading: false }, () => {
      $(this.modalRef).modal('hide');
      this.props.onAction({
        type: this.props.dataEdit ? 'updated' : 'created',
        payload: resp.data
      });

      if (this.props.dataEdit) {
        toastr.success('Group updated');
      } else {
        toastr.success('Group created');
      }
    });
  };

  error = err => {
    if (err.response.data) {
      const message = err.response.data.join(', ');
      toastr.error(message);
    }

    this.setState({ loading: false });
  };
}

ModalEditCreate.propTypes = {
  locations: PropTypes.array.isRequired,
  dataEdit: PropTypes.object,
  visible: PropTypes.bool,
  onClosed: PropTypes.func,
  onAction: PropTypes.func
};

ModalEditCreate.defaultProps = {
  dataEdit: null,
  visible: false
};

export default ModalEditCreate;
